export enum CheckedValue {
    left = 'left',
    right = 'right'
}

export enum ToggleBtnLabel {
    And = 'AND',
    Or = 'OR'
}
